import { Wrench, Clock } from 'lucide-react'
import { format, parseISO } from 'date-fns'

interface Props {
  message?: string
  endTime?: string
}

export default function MaintenancePage({ message, endTime }: Props) {
  const parsedEnd = endTime ? (() => { try { return parseISO(endTime) } catch { return null } })() : null

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-50 to-orange-100 flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Logo */}
        <div className="flex justify-center">
          <div className="h-16 w-16 rounded-2xl bg-brand-500 flex items-center justify-center shadow-lg">
            <span className="text-white font-black text-2xl">P</span>
          </div>
        </div>

        {/* Icon */}
        <div className="flex justify-center">
          <div className="h-20 w-20 rounded-full bg-white shadow-card flex items-center justify-center">
            <Wrench className="h-9 w-9 text-brand-500" />
          </div>
        </div>

        {/* Heading */}
        <div className="space-y-2">
          <h1 className="text-3xl font-black text-gray-900">We'll be back soon</h1>
          <p className="text-gray-600 text-base leading-relaxed">
            {message && message.trim()
              ? message
              : 'Palstro is undergoing scheduled maintenance. We are working hard to improve your experience.'}
          </p>
        </div>

        {/* Estimated time */}
        {parsedEnd && (
          <div className="inline-flex items-center gap-2 bg-white rounded-2xl px-5 py-3 shadow-card text-sm">
            <Clock className="h-4 w-4 text-brand-500 flex-shrink-0" />
            <span className="text-gray-600">
              Estimated return: <strong className="text-gray-900">{format(parsedEnd, 'MMM d, yyyy h:mm a')}</strong>
            </span>
          </div>
        )}

        {/* Footer */}
        <p className="text-xs text-gray-400">
          © {new Date().getFullYear()} Palstro · All systems will be restored shortly
        </p>
      </div>
    </div>
  )
}
